"use client";
import React from "react";

interface BackdropProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}

const Backdrop: React.FC<BackdropProps> = ({ isOpen, setIsOpen }) => {
  const setOpen = (isOpened: boolean) => {
    if (setIsOpen) setIsOpen(isOpened);
  };
  return isOpen ? (
    <div
      className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen min-w-max min-h-max bg-[#0B2841] bg-opacity-50 flex justify-center items-center z-50 cursor-default"
      onClick={() => setOpen(false)}
    ></div>
  ) : null;
};

export default Backdrop;
